import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { HistoryAdvancedFilter } from '@/entities/history';

const ENDPOINT_HISTORY_URI = '/endpointHistory';

export const getAllEndpointHistories = async (
  filter: HistoryAdvancedFilter,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc'
) => {
  const params = new URLSearchParams();

  params.append('filter', JSON.stringify(filter));
  params.append('page', String(page));
  params.append('limit', String(limit));
  params.append('sortBy', String(sortBy || ''));
  params.append('sortDirection', String(sortDirection));

  return requestApi({
    url: `${ENDPOINT_HISTORY_URI}/all?${params.toString()}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveEndpointHistories = async () => {
  return requestApi({
    url: `${ENDPOINT_HISTORY_URI}/totalActive`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
